// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"81fc06de","487":"752aa9f9","489":"9ab6e3ec","651":"8ba45e08","679":"11def34d","794":"c16d9041","969":"792e12d9"}[chunkId] + ".chunk.js";
};